import { Directive, ElementRef, Input } from '@angular/core';


@Directive({
    selector: '[showIconIf]',
    standalone: false
  })
  export class CustomDirective{

    private _showIconIf:boolean = false;
    @Input() 
    set showIconIf(value: boolean) {
      this._showIconIf=value;
      this.setClass();
    }

    private _reverse:boolean = false;
    @Input() 
    set showIconIfReverse(value: boolean) {
      this._reverse = value;
      this.setClass();
    }

    constructor(private elementRef: ElementRef)
    {}
    setClass()
    {
        if(this._showIconIf)
        {
            this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-top";
            if(this._reverse)
            {
                this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-bottom";
            }
        }
        else{
            this.elementRef.nativeElement.className = "";
        }
    }
  }

// @Directive({
//     selector: "[appCustom]"
// })

// export class CustomDirective implements AfterViewInit
// {

//     @Input() options: string;
//     @Input() reverse: boolean;
//     constructor(private renderer: Renderer2,
//                 private elementRef: ElementRef)
//         {
//             //alert('Sorting Name - ' + this.options);
//             //alert('isDesc - ' + this.reverse);
//             //alert(this.elementRef.nativeElement);
//             //console.log(this.elementRef);
//             //console.log(this.renderer);
//             this.setClass();
//             //this.renderer.addClass(this.elementRef.nativeElement, "glyphicon glyphicon-triangle-bottom")
//             //this.elementRef.nativeElement.classList.add("glyphicon glyphicon-triangle-bottom")
//             //this.renderer.setAttribute(this.elementRef.nativeElement, 'class', 'glyphicon glyphicon-triangle-bottom');

//     }

//     setClass()
//     {
//         this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-top";
//         if(this.reverse)
//         {
//             this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-bottom";
//         }
//     }

//     @HostListener('click') click(eventData: Event) {
//         this.reverse = !this.reverse;
//         this.setClass();
//     }

    

//     // @Input() set myIf(toShowOderDir: boolean) {
//     //     alert('Sorting Name - ' + this.options);
//     //     if (!toShowOderDir) {
//     //       // If the value is true, add template to the DOM
//     //       this.elementRef.nativeElement.className = "";
//     //     }
//     //     else
//     //     {
//     //         if(this.reverse)
//     //         {
//     //             this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-bottom";
//     //         }
//     //         else{
//     //             this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-top";
//     //         }
//     //     }
//     //   }
 
//     ngAfterViewInit(): void {
//         // alert(this.options);
//         // alert(this.elementRef.nativeElement);
//      }
 
//  }


//   @Directive({
//     selector: '[permissionIf]'
//   })
//   export class CustomDirective{

//     private _permissionIf:boolean;
//     @Input() 
//     set permissionIf(value: boolean) {
//       this._permissionIf=value;
//       this.setClass();
//     }

//     private _reverse:boolean;
//     @Input() 
//     set permissionIfReverse(value: boolean) {
//       this._reverse = value;
//       this.setClass();
//     }

//     constructor(private elementRef: ElementRef)
//     {}
//     setClass()
//     {
//         if(this._permissionIf)
//         {
//             this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-top";
//             if(this._reverse)
//             {
//                 this.elementRef.nativeElement.className =  "glyphicon glyphicon-triangle-bottom";
//             }
//         }
//         else{
//             this.elementRef.nativeElement.className = "";
//         }
//     }
//   }